import React from "react";

import { htmlSafe, hasStartAndEndTag } from "modules/utils";
import { DegreesBannerLargeProps } from ".";

const SixtyThreeDegreesBannerLargeSkeleton: React.FC<DegreesBannerLargeProps> = ({ copy, subheading }) => {
  return (
    <div style={{ visibility: "hidden" }}>
      <div>
        <div>
          <div>
            {subheading && (
              <div>
                <h2>{subheading}</h2>
              </div>
            )}
            <div>
              <div>
                <div>{hasStartAndEndTag(copy) ? htmlSafe(copy) : <p>{htmlSafe(copy)}</p>}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SixtyThreeDegreesBannerLargeSkeleton;
